import { MutationOptions } from 'react-query';
import { updateOrderShowDeltaT } from './orders.api';
import { UpdateShowDeltaTResponse } from './orders.schema';

export const getUpdateOrderShowDeltaTMutation = (): MutationOptions<
  UpdateShowDeltaTResponse,
  Error,
  { orderId: number; showDeltaT: boolean }
> => ({
  mutationFn: ({ orderId, showDeltaT }) =>
    updateOrderShowDeltaT(orderId, showDeltaT),
});
